import React, { useEffect, useState } from 'react';
import { apiFetch, parseJsonSafe, API_URL } from '../utils/api';

const GalleryPage = () => {
  const token = localStorage.getItem('token');
  const [images, setImages] = useState([]);
  const [uploading, setUploading] = useState(false);
  const normalizeDriveImageUrl = (value) => {
    if (!value) return '';
    const raw = String(value);
    if (!raw.includes('drive.google.com') && !raw.includes('drive.usercontent.google.com')) return raw;
    const match = raw.match(/\/file\/d\/([^/]+)/) || raw.match(/[?&]id=([^&]+)/);
    if (!match) return raw;
    return `/api/uploads/drive/${match[1]}`;
  };
  const toAbsoluteUrl = (url) => {
    if (!url) return '';
    const normalized = normalizeDriveImageUrl(url);
    if (normalized.startsWith('http') || normalized.startsWith('//')) return normalized;
    if (API_URL) return `${API_URL}${normalized}`;
    try {
      return new URL(normalized, window.location.origin).toString();
    } catch (_e) {
      return normalized;
    }
  };

  const handleUnauthorized = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('userEmail');
    window.location.href = '/login';
  };

  const loadImages = async () => {
    try {
      const res = await apiFetch('/api/uploads/images', { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (res.ok) setImages(data || []);
    } catch (err) {
      console.error('Error cargando galería', err);
    }
  };

  useEffect(() => {
    loadImages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleUpload = async (file) => {
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    try {
      setUploading(true);
      const res = await apiFetch('/api/uploads/images', {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: formData
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo subir');
      loadImages();
    } catch (err) {
      alert(err.message);
    } finally {
      setUploading(false);
    }
  };

  const handleDelete = async (idOrFilename) => {
    if (!window.confirm('¿Eliminar esta imagen?')) return;
    try {
      const res = await apiFetch(`/api/uploads/images/${idOrFilename}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error('No se pudo eliminar');
      setImages((prev) => prev.filter((img) => String(img.id) !== String(idOrFilename) && img.filename !== idOrFilename));
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h2 className="mb-0">Galería</h2>
          <div className="text-muted small">Imágenes subidas desde email marketing y otros módulos.</div>
        </div>
        <label className="btn btn-primary mb-0">
          Subir imagen
          <input
            type="file"
            accept="image/*"
            hidden
            onChange={(e) => handleUpload(e.target.files?.[0])}
            disabled={uploading}
          />
        </label>
      </div>
      <div className="row g-3">
        {images.length ? images.map((img) => (
          <div className="col-md-3 col-sm-4 col-6" key={img.id || img.filename}>
            <div className="border rounded p-2 h-100 d-flex flex-column">
              <div className="mb-2" style={{ background: '#f5f5f5', borderRadius: 8, overflow: 'hidden' }}>
                <img
                  src={toAbsoluteUrl(img.url)}
                  alt={img.filename}
                  style={{ width: '100%', height: 'auto', display: 'block', objectFit: 'contain', maxHeight: 220 }}
                />
              </div>
              <div className="small text-truncate">{img.filename}</div>
              <div className="small text-muted">{Math.round(img.size / 1024)} KB</div>
              <button className="btn btn-sm btn-outline-danger mt-2" onClick={() => handleDelete(img.id || img.filename)}>
                Eliminar
              </button>
            </div>
          </div>
        )) : (
          <div className="col-12 text-muted small">No hay imágenes subidas.</div>
        )}
      </div>
    </div>
  );
};

export default GalleryPage;
